import apiClient from './client';

export const listClientTickets = (params) => apiClient.get('/client-tickets', { params }).then((r) => r.data);
export const getClientTicket = (id) => apiClient.get(`/client-tickets/${id}`).then((r) => r.data);
export const createClientTicket = (payload) => apiClient.post('/client-tickets', payload).then((r) => r.data);
export const updateClientTicket = (id, payload) => apiClient.put(`/client-tickets/${id}`, payload).then((r) => r.data);
export const addClientTicketComment = (id, comment) => apiClient.post(`/client-tickets/${id}/comments`, { comment }).then((r) => r.data);
